import type { CaseDetail } from '../portfolio';

const kaoInfoCase: CaseDetail = {
  id: 'kao-info',
  project: 'Kao Information Meeting & Retail Strategy',
  client: '花王株式会社',
  year: 'Archive',
  category: 'Retail Strategy / VMD / Experience',
  role: 'Retail Strategy / VMD / POP / Communication / Shelf Display',
  issue: '花王の商品価値を、小売店舗で効果的に伝えるための販売接点設計が必要。高齢者向け商品や男性向け育毛剤など、専門性の高い商品の訴求が課題だった。',
  challenge: '視認性の高い陳列と、用途別のPOPで、専門性の高い商品の優位性を店頭でわかりやすく表現すること。高齢者の視力を考慮した訴求設計。',
  insight: '遠景・中景・近景それぞれの視認性を考慮した陳列設計が購買の決め手になる。補色関係の色使いで、他社製品との差別化と目立ち度を向上させられる。',
  strategy: 'UU（大人用紙おむつ）とSUCCESS（薬用育毛剤）の店頭展開戦略を設計。色彩調査に基づいた陳列計画、遠近別の視認性設計、用途別POP、立体陳列什器で商品優位性を訴求。20代後半〜30代男性をターゲットにした育毛剤の売場設計も実施。',
  experience: '店頭POP、陳列什器、サンプリングツール、色彩設計、ジャンボパッケージを通じた販売接点設計。',
  output: 'Retail Strategy / VMD / POP / Shelf Display / Sampling Tools / Color Planning',
  impact: '店頭での商品認知向上と、購買意欲の喚起。高齢者向け商品の視認性改善と、男性向け育毛剤の新規顧客層獲得に貢献。',
  images: [
    {
      src: '/assets/migrated/f650aaadec9dd34210a9.webp',
      caption: '頭皮頭髪ケア売り場展開イメージ — エンド最上段展開（A:機能訴求展開 / B:ダイレクト訴求展開）',
    },
    {
      src: '/assets/migrated/b1107d46df07dee1fdcd.webp',
      caption: '市場状況 — チャネル別販売実績推移（チャネル別でみるシェアについて）',
    },
    {
      src: '/assets/migrated/0763eccd3533b265ceb1.webp',
      caption: 'キービジュアル — SUCCESS KEY for BUSINESS トップボードイメージ',
    },
    {
      src: '/assets/migrated/43b33352a44f65e897df.webp',
      caption: 'サクセスブランドの分析 — SWOT分析',
    },
    {
      src: '/assets/migrated/e83efd714ff5b95715a9.webp',
      caption: 'サクセス：ヘアケア商品（育毛剤関連）に着目した理由 — 市場分析',
    },
    {
      src: '/assets/migrated/e832b00bb56080f68067.webp',
      caption: 'ターゲットについて — 20代後半から40代のビジネスマンをメインターゲットに設定',
    },
    {
      src: '/assets/migrated/a0a3108cebbad2588e51.webp',
      caption: '売り場の展開について — プロモーションコンセプト：身だしなみ意識を店頭で喚起させる売場を目指す',
    },
    {
      src: '/assets/migrated/a12fcf2d6ddd6011de27.webp',
      caption: '定番棚（レールシート）のデザイン用途説明 — ダイレクト訴求の展開',
    },
    {
      src: '/assets/migrated/07008dc736f520fd3c6d.webp',
      caption: '頭皮頭髪ケア売り場展開イメージ — 定番棚600W（A:機能訴求展開 / B:ダイレクト訴求展開）',
    },
    {
      src: '/assets/migrated/f4661773437ca8638395.webp',
      caption: '定番棚（レールシート）のデザイン用途説明 — 機能訴求の展開',
    },
    {
      src: '/assets/migrated/82e895343966acc40a84.webp',
      caption: '市場状況 — リリーフのマーケットシェアについて（花王リリーフはシェア第三位）',
    },
    {
      src: '/assets/migrated/3858eab2a8f833cf330e.webp',
      caption: 'リリーフ商品のシェアの向上を図るには？！ — 仮説：店頭課題とABC改善軸（視認性・わかりやすさ・目立ち度）',
    },
    {
      src: '/assets/migrated/42b57a935f8c6c03e4a5.webp',
      caption: '超高齢化社会 — 大人用おむつの需要拡大が予測。今回はリリーフに着目！',
    },
    {
      src: '/assets/migrated/7be6f3ead7d0907a3168.webp',
      caption: '店頭ツール施策一覧 — 近景用ツール（商品分類/商品認知）：生活の仕方分類POP・用途別POP・商品特徴POP',
    },
    {
      src: '/assets/migrated/ef2d050a6b15bf71159c.webp',
      caption: '店頭ツール施策一覧 — 中景用ツール（ブランド認知）：突き出しPOP・プッシュイン・連ねて使うことでコーナーをくくる',
    },
    {
      src: '/assets/migrated/79136df6c56878232ee5.webp',
      caption: '情報交換会 表紙 — 【薬用シャンプー】を中心としたサクセスブランド 店頭プロモーション企画のご提案（レンゴー株式会社 2011.08.01）',
    },
    {
      src: '/assets/migrated/4d61b144b8b4a7f7d563.webp',
      caption: '店頭でライフリーが目立つ理由とは？ — 商品形態軸・耐久時間軸・使用シチュエーション軸のセグメント化',
    },
    {
      src: '/assets/migrated/5677e95f1bd00882977d.webp',
      caption: 'シェービングケア売り場展開イメージ — SUCCESS KEY for BUSINESS 定番展開（A:機能訴求展開 / B:ダイレクト訴求展開）',
    },
    {
      src: '/assets/migrated/bd845265e889d164cd24.webp',
      caption: 'サクセス 商品コンセプト — 「身だしなみ」を通じて社会人男性を応援するブランド',
    },
    {
      src: '/assets/migrated/d1a956ee69d99ed8009a.webp',
      caption: '課題解決に向けて — 売り場の課題を解決するための考え方：売り場整理・ブランドテーマ・買いやすさの追求',
    },
    {
      src: '/assets/migrated/6af9278f9c6e40f39e42.webp',
      caption: '店頭施策ツール一覧 — SUCCESS KEY for BUSINESS 総合ツール展開（レールPOP・フロアディスプレイ・ハンガー・ボード・リーフレット）',
    },
    {
      src: '/assets/migrated/01e3d9c73cba8bf8594a.webp',
      caption: '店頭ツール施策のご提案 — リリーフ商品のシェア向上をめざしたツール施策の提案',
    },
    {
      src: '/assets/migrated/f4b78b66a0921211f7f5.webp',
      caption: 'プロモーションコンセプト — SUCCESS KEY for Business 〜ビジネス成功のカギは、身だしなみから！〜',
    },
    {
      src: '/assets/migrated/acbb338f9a5d98d3df69.webp',
      caption: '店頭ツール施策一覧 — 遠景用ツール（売り場認知）：トップボード・補色関係の色提示・展開例',
    },
    {
      src: '/assets/migrated/54aff08e02c0c0bdeb96.webp',
      caption: '花王情報交換会 表紙 — リテールプロモーション企画（リリーフ＋SUCCESS レンゴー株式会社）',
    },
    {
      src: '/assets/migrated/89a87c57309825cbe78c.webp',
      caption: 'C 目立ち度UP訴求！商品をくくる＝目立つ色は？ — ライフリー（他社）とリリーフ（花王）の色彩カラーチャート比較検証',
    },
    {
      src: '/assets/migrated/d16ea63db066fbe419d1.webp',
      caption: 'シェア率の高いドラッグストアでの展開 — リリーフ商品のシェア向上へ：ブランド別分類で視認性向上',
    },
    {
      src: '/assets/migrated/9dde58d78af3d92bb237.webp',
      caption: '店頭施策 ツールデザイン — SUCCESSブランドの店頭ツールデザイン',
    },
    {
      src: '/assets/migrated/f4f35a2376e208404378.webp',
      caption: 'B わかりやすさの向上 — 視認性や可読性を考慮した、店頭ツール展開の実現とお客様の誘導。高齢者の方に配慮した見やすさと手に取りやすい店頭ツール展開',
    },
    {
      src: '/assets/migrated/f54fcfd5d0ed87cf04ca.webp',
      caption: 'プロモーションコンセプトについての考え方 — 売り場状況と消費者の購買行動を考慮した効果的なプロモーションコンセプト開発。売り場で「サクセス」を印象づける表現を展開し、購買につなげる',
    },
    {
      src: '/assets/migrated/00faa3b644b3e9a533be.webp',
      caption: '店頭ツール施策一覧 — 近景用ツール（商品分類/商品認知）：手触り見本POP…商品特徴である肌触りを伝えるPOP。ポップアップで生地部分を強調',
    },
    {
      src: '/assets/migrated/80c79b8ef54893b0d07b.webp',
      caption: 'プロモーションコンセプト考案の背景 — 「職場での身だしなみ」についての調査結果。髪や頭皮、ヒゲについての身だしなみ意識を店頭で喚起',
    },
    {
      src: '/assets/migrated/d1aea0dfdb95a0d6b2c5.webp',
      caption: '課題の設定 — 売り場の考察からプロモーション課題を設定：売り場がわかりづらい・メッセージが伝わりづらい・商品が買いづらい',
    },
    {
      src: '/assets/migrated/3190f75b6471528f3bfd.webp',
      caption: 'A 視認性の向上として — ドラッグストアでの遠景・中景からみたときの注視点。購入者が高齢者が多いと予測されるので、遠景・中景からみて視認性の高い位置による気づき訴求をおこなう',
    },
    {
      src: '/assets/migrated/3a2b13fb920e4bcf34f4.webp',
      caption: '頭皮頭髪ケア売り場展開イメージ — アウト展開：フロアディスプレイ（A+B:機能＋ダイレクト訴求展開）／ハンガーディスプレイ（B:ダイレクト訴求展開）',
    },
    {
      src: '/assets/migrated/aedcadd3f56229601177.webp',
      caption: 'サクセスブランド ラインナップの確認 — 頭皮頭髪ケア（シャンプー・洗浄ブラシ・リンス・育毛トニック・Tフラグ）／スタイリング／シェービングケア／白髪ケア',
    },
    {
      src: '/assets/migrated/33537839e3edb453cb65.webp',
      caption: '「思い」を伝える。 — SUCCESSブランドのコミュニケーションコンセプト',
    },
    {
      src: '/assets/migrated/735567992a96404db1cf.webp',
      caption: 'リリーフ 店頭展開施策のご提案 — レンゴー株式会社 2011.02.24',
    },
    {
      src: '/assets/migrated/506967a0294a5039136c.webp',
      caption: 'アウト展開：ハンガーディスプレイのデザイン用途説明 — フック型式ハンガーディスプレイ。手触り見本・W使用で効果アップ（シャンプー＋ブラシ）・トライアルセット入りPPケース',
    },
    {
      src: '/assets/migrated/d21278929bf2b7f05dde.webp',
      caption: '頭皮頭髪ケア売り場展開イメージ — 定番棚900W（A:機能訴求展開 / B:ダイレクト訴求展開）',
    },
  ],
};

export default kaoInfoCase;